import { createContext, useReducer } from 'react';
import type { SearchAppContextType, SearchDataProps } from '../../types';
import {
  searchAppReducer,
  createInitialSearchAppState,
} from './search-app-reducer';
import type { SearchAppAction } from './search-app-reducer';

const defaultDispatch: SearchDispatchContextValue = {
  dispatch: () => {},
};

export const SearchAppContext = createContext<SearchAppContextType>(
  createInitialSearchAppState(
    typeof window !== 'undefined' ? window.location.search : '',
  ),
);

export type SearchDispatchContextValue = {
  dispatch: React.Dispatch<SearchAppAction>;
};

export const SearchAppDispatchContext =
  createContext<SearchDispatchContextValue>(defaultDispatch);

export function SearchAppProvider({
  children,
  pageUrlPath = '',
  defaultQuery = '',
  showFacets = true,
  showTextSearch = true,
  pageMetadataFilters,
}: {
  children: React.ReactNode;
  pageUrlPath?: string;
  defaultQuery?: string;
  showFacets?: boolean;
  showTextSearch?: boolean;
  pageMetadataFilters?: SearchDataProps['pageMetadataFilters'];
}) {
  const [state, dispatch] = useReducer(searchAppReducer, undefined, () =>
    createInitialSearchAppState(
      typeof window !== 'undefined' ? window.location.search : '',
      {
        pageUrlPath,
        defaultQuery,
        showFacets,
        showTextSearch,
        pageMetadataFilters,
      },
    ),
  );

  return (
    <SearchAppContext.Provider value={state}>
      <SearchAppDispatchContext.Provider value={{ dispatch }}>
        {children}
      </SearchAppDispatchContext.Provider>
    </SearchAppContext.Provider>
  );
}
